<template>
  <footer class="footer">
    <div>Copyright © 2024-2026 JXZC. All Rights Reserved. 匠心致诚公司 版权所有</div>
    <div>
      <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noopener noreferrer">粤公网安备12345678号</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
};
</script>

<style scoped>
.footer {
  position: relative;
  background: #f1f3f6;
  color: #888;
  text-align: center;
  padding: 24px 0 16px 0;
  font-size: 0.8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 40px;
}
.footer > div {
  display: inline-block;
  margin: 0 10px;
}
.footer div a {
  color: #888;
}
</style> 